module.exports = __webpack_public_path__ + "static/media/date-icon.fa5f951f.svg";